<template>
  <div style="display: flex; flex-direction: column;">
    <div v-if="data.type == 'texteditor'">
        <l-editor ref="quillEditor" v-model="value2" :options="{  theme:'snow',placeholder: $t('请输入内容...')}"  >
        </l-editor>
    </div>
    <component v-else :is="getComponent(data.type)"
               v-model="value2"
               v-bind="data"
               :placeholder="$t(data.placeholder)"
               :options="myOptions"

               :size="data.subfield ? 'mini':data.size"
               :activeValue="toValueType(data.valueType,data.activeValue)"
               :inactiveValue="toValueType(data.valueType,data.inactiveValue)"

                :dataUpCtrl = "dataUpCtrl"
               :disabled="disabled"
style="flex: 0 0 auto;"
                @change="handleChange"         
               >
        <span v-if="data.html"
            v-html="data.html"></span>
        <template v-if="['input'].includes(data.type) && data.prepend" #prepend >
            {{data.prepend}}
        </template>
        <template v-if="['input'].includes(data.type) && data.append" #append >
            {{data.append}}
        </template>
    </component>
  </div>
</template>
<script>
import mixin from '../../mixin'
export default {
    name: 'viewer-form-item',
    mixins: [mixin()],
    props: {
        value:{},
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        formData:{
            type: Object,
            default: () => {
                return {}
            }
        },
        isForm:{// 是否表单里的对象，用来区分对查询框的操作
            type:Boolean,
            default:false
        },
        upformData:{
            type: Object,
            default: () => {
                return {}
            }
        },
        upCtrls:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        isRead:{// 是否表单里的对象，用来区分对查询框的操作
            type:Boolean,
            default:false
        },
        dataSource: {
            type: Array,
            default: ()=>{
                return []
            }
        },
        lineHeight:{
            type: Number,
            default: 20
        }
    },
    data () {
        return {
           
        }
    },
    computed:{
        value2:{
            get(){
                return this.value
            },
            set(val){
                this.$emit('input', val)
            }
        },
        disabled(){
            if(this.isRead){
                return true
            }

            if(this.data.subfield){
                const abledList = this.formData.abledList || []
                if(this.formData.disabled && abledList.indexOf(this.data.prop) == -1 ){
                    return true
                }
            }
            return this.data.disabled
        },
        computedHeight() {
            return `${this.lineHeight * (this.data.rows||2) + 42}px`;
        },
        isReadonly(){
            return this.data.disabled || this.isRead || this.data.readony
        }
    },
    mounted() {
        this.$nextTick(() => {
                this.setEditorReadOnly(this.isReadonly)
            });
    },
    methods: {
        setEditorReadOnly(isReadonly) {
            if (this.$refs.quillEditor && this.$refs.quillEditor.quill) {
                // 设置编辑状态
                this.$refs.quillEditor.quill.enable(!isReadonly);
                
                // 控制工具栏显示
                const toolbar = this.$el.querySelector('.ql-toolbar');
                if (toolbar) {
                    toolbar.style.display = isReadonly ? 'none' : '';
                }
            }
        },
        toValueType(type,value){
            if(!this.$validatenull(value) && !this.$validatenull(type)){
                switch(type){
                    case 'boolean':
                        return value == 'true';
                    case 'string':
                        return value;
                    case 'number':
                        return Number(value);
                }
            }
        },
        handleChange(changeData){
            this.$nextTick(()=>{
                // 1.改变级联数据，清空级联数据
                if(["checkbox","radio","select","selectMultiple","treeselect","layerselect",'companySelect','departmentSelect','userSelect'].includes(this.data.type)){
                    this.clearSubValue(this.data.prop)
                }
                // 根据右侧赋值字段给表单赋值地图信息
                if (this.data.type == "layerbmap") {
                    if (this.data.bindaddr) {
                        if(changeData){
                            this.$set(this.formData, this.data.bindaddr, changeData.address); //设置绑定地址
                        }
                        else{
                            this.$set(this.formData, this.data.bindaddr, ''); //设置绑定地址
                        }
                    }
                    if (this.data.bindaddrpoint) {
                        if(changeData){
                            this.$set(this.formData,this.data.bindaddrpoint,`${changeData.lng},${changeData.lat}`);//设置绑定经纬度
                        }
                        else{
                            this.$set(this.formData, this.data.bindaddrpoint, ''); //设置绑定地址
                        }
                    }
                }
                // 弹窗赋值
                if(this.data.type == 'layerselect'){
                    var multiple = this.data.multiple; 
                    var rowdatas = multiple ?changeData : [changeData];
                    var columns = this.data.columns;
                    var source = this.data.source //reset overwrite append
                    if(source == 'reset')
                        this.dataSource.len = 0

                    var currentIndex = this.isForm ? -1 : this.dataSource.findIndex(t=>t == this.formData)
                    var currentEditForm = this.$deepClone(this.formData)
                    rowdatas.forEach(rowdata=>{       
                        
                        var formRow = currentIndex != -1 ? this.dataSource[currentIndex] : 
                            (this.isForm?this.formData : this.$deepClone(currentEditForm));
                        columns.forEach(col=>{
                            if(col.valueKey){
                                if(rowdata){
                                    this.$set( formRow, col.valueKey, rowdata[col.prop])
                                }
                                else{
                                    this.$set( formRow, col.valueKey, undefined)
                                }
                            }
                        })
                        //下一个更新行，或者新增行，或者编辑行
                        var nextRowIndex = -1;
                        //属于子表明细
                        if(!this.isForm){ 
                            var dataSource1 = this.dataSource.filter(t=>t != this.formData);
                            columns.filter(t=>t.unique).forEach(uniqueColumn=>{
                                dataSource1 = dataSource1.fiter(t=>t[uniqueColumn.valueKey] == formRow[uniqueColumn.valueKey])
                                //更新重复行
                                if(source != 'overwrite' ){
                                    nextRowIndex = currentIndex;
                                    currentIndex = this.dataSource.findIndex(t=>t==dataSource1[0])
                                }
                            }) 
                            //未定义重复键或者不重复
                            if(columns.filter(t=>t.unique).length == 0 || dataSource1.length == 0 || currentIndex != -1){
                                var newValue = rowdata[this.data.dataValueKey];
                                this.$set(formRow, this.data.prop, newValue)
                                if(currentIndex == -1){
                                    this.dataSource.push(formRow);
                                    currentIndex = this.dataSource.length - 1
                                }
                                else{
                                    this.copyData(formRow, this.dataSource[currentIndex])
                                }
                                this.$emit('change1',{prop:this.data.prop, obj:newValue},  this.data, formRow, currentIndex)
                            }
                        }
                        else{
                            this.$emit('change',{prop:this.data.prop,obj:rowdata[this.data.dataValueKey]})
                        }
                        currentIndex = nextRowIndex
                    })
                    return;
                }
                this.$emit('change',{prop:this.data.prop,obj:changeData})
            })
        },
        copyData(from, to){
            if(from == to)
                return;
            for(var key in from){
                to[key] = from[key]
            }
        },
        clearSubValue(upProp) {
            if(this.upCtrls[upProp]){
                this.upCtrls[upProp].forEach((prop)=>{
                    this.$set(this.formData,prop,'')
                    this.clearSubValue(prop)
                })
            }
        }
    }
}
</script>
